import React, { useEffect, useRef } from 'react'

import { styled } from '@acorns/web-components'

import { style } from 'theme'

const Anchor = styled.a`
  margin: 0px auto;
  color: ${style(theme => theme.colors.stone)};
  font-size: 8pt;
  font-style: italic;
  text-align: center;
  cursor: pointer;
  text-decoration: underline;
`

export const OneTrustLink = () => {
  const ref = useRef(null)

  // Everytime user opens the OneTrust modal, we want to change its text and external link
  // The modal is mounted and unmounted by OneTrust, that's why we need to do it on the click event
  // istanbul ignore next
  const oneTrustAnchorClickListener = () => {
    const oneTrustModalTitleLabel = 'Your Privacy Choices'
    const divInsideModalOneTrust = document.getElementById('ot-pc-desc')

    if (divInsideModalOneTrust) {
      divInsideModalOneTrust.innerHTML =
        'This site employs cookies and similar technologies that facilitate sharing of personal information (e.g., IP address, device/advertising ID, usage activity) with third-party advertising services to help them target the advertising you see online based on your activity on this site and other online services. See our <a href="https://www.acorns.com/privacy" class="privacy-notice-link" rel="noopener" target="_blank" aria-label="More information about your privacy, opens in a new tab" tabindex="0">Privacy Policy</a> for details. You may opt-out of such sharing by Acorns by selecting “Yes” below and clicking “Confirm”. Your request to opt-out will apply only to the device and browser from which you submit the request.'
    }

    const textTitleModalOneTrustElement = document.getElementById('ot-pc-title')

    if (textTitleModalOneTrustElement) {
      textTitleModalOneTrustElement.innerText = oneTrustModalTitleLabel
    }

    const toggleDivOptOut = document.getElementsByClassName('ot-tgl')?.item(0)

    if (toggleDivOptOut) {
      const htmlToggleDiv = toggleDivOptOut.outerHTML

      if (htmlToggleDiv && !htmlToggleDiv.includes('Yes')) {
        const leftText = document.createElement('span')
        leftText.id = 'leftNoToggleText'
        const leftTextNode = document.createTextNode('No')
        leftText.appendChild(leftTextNode)

        toggleDivOptOut.insertBefore(leftText, toggleDivOptOut.firstChild)

        const rightText = document.createElement('span')
        rightText.id = 'rightNoToggleText'
        const rightTextNode = document.createTextNode('Yes')
        rightText.appendChild(rightTextNode)

        toggleDivOptOut.appendChild(rightText)

        toggleDivOptOut.id = 'toogleClassOptOut'
      }
    }
  }

  useEffect(() => {
    const element = ref.current

    // OneTrust override the onClick event, so we need to add a listener.
    element?.addEventListener('click', oneTrustAnchorClickListener)
    return () => element?.removeEventListener('click', oneTrustAnchorClickListener)
  }, [])

  return (
    <Anchor ref={ref} id="ot-sdk-btn-new-style" className="ot-sdk-show-settings">
      Your privacy choices
    </Anchor>
  )
}
